export default {
  src: 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js',
  autoBlockSrc:
    'https://cdn.cookielaw.org/consent/66bc6759-472b-4655-a86a-83b5d34c3611-test/OtAutoBlock.js',
  domainScript: '66bc6759-472b-4655-a86a-83b5d34c3611-test',
};
